import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Courses from "../../api/Courses";
import { calculateAverageRating } from "../../Helpers/calculateAverageRating";
import { MatchLocationToCurrency } from "../../main-component/Extensions/MatchLocationToCurrency";
import Cookies from 'js-cookie';
import Search from "../Search/Search";
import "./styles/CourseSectionS3.css"
const ClickHandler = () => {
    window.scrollTo(10, 0);
}






const CourseSectionS3 = (props) => {

    const handleClickedChildToParent = (courseId) => {
        props.onData(courseId);
    }

    const savePageNumber = () => {
        localStorage.setItem("currentPageNumber",props.paginationNumber)
    }

    const [courses, setCourses] = useState([]);
    useEffect(() => {
        if (props.courses) {
            setCourses(props.courses);
        }
    }, [props.courses]);

    const gradients = [
        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
        'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
        'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
        'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    ];

    return (
        <div className={`wpo-popular-area section-padding ${props.pClass} course-section`}>
            <div style={{ marginBottom: "30px" }}></div>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div className="wpo-popular-wrap">
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '30px',
                        padding: '10px 0'
                    }}>
                        {courses.map((course, index) => (
                           <div 
                                key={index}
                                className="modern-course-card"
                                style={{
                                    background: '#fff',
                                    borderRadius: '16px',
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    cursor: 'pointer',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                                }}
                           >
                               {/* Image Section with Gradient Overlay */}
                               <div style={{
                                   position: 'relative',
                                   width: '100%',
                                   height: '220px',
                                   background: gradients[index % gradients.length],
                                   overflow: 'hidden'
                               }}>
                                   {course.courseImage ? (
                                       <img 
                                           src={course.courseImage} 
                                           alt={course.courseName}
                                           style={{
                                               width: '100%',
                                               height: '100%',
                                               objectFit: 'cover',
                                               opacity: 0.9,
                                               transition: 'transform 0.4s ease'
                                           }}
                                           onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                           onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                       />
                                   ) : (
                                       <div style={{
                                           width: '100%',
                                           height: '100%',
                                           display: 'flex',
                                           alignItems: 'center',
                                           justifyContent: 'center',
                                           fontSize: '48px'
                                       }}>
                                           📚
                                       </div>
                                   )}
                                   
                                   {/* Price Badge */}
                                   <div style={{
                                       position: 'absolute',
                                       bottom: '16px',
                                       right: '16px',
                                       background: course.coursePrice === 0 ? '#10b981' : '#f59e0b',
                                       color: '#fff',
                                       padding: '8px 16px',
                                       borderRadius: '25px',
                                       fontWeight: '700',
                                       fontSize: '16px',
                                       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '4px'
                                   }}>
                                       {course.coursePrice === 0 ? (
                                           'Ücretsiz'
                                       ) : (
                                           <>{MatchLocationToCurrency()}{course.coursePrice}</>
                                       )}
                                   </div>
                               </div>
                               
                               {/* Content Section */}
                               <div style={{
                                   padding: '24px',
                                   display: 'flex',
                                   flexDirection: 'column',
                                   gap: '16px',
                                   flexGrow: 1
                               }}>
                                   {/* Rating */}
                                   <div style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '8px'
                                   }}>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '4px',
                                           background: '#fef3c7',
                                           padding: '4px 12px',
                                           borderRadius: '20px'
                                       }}>
                                           <span style={{ color: '#f59e0b', fontSize: '16px' }}>⭐</span>
                                           <span style={{ 
                                               fontWeight: '600', 
                                               fontSize: '14px',
                                               color: '#92400e'
                                           }}>
                                               ({calculateAverageRating(course.ratings)})
                                           </span>
                                       </div>
                                   </div>
                                   
                                   {/* Course Title */}
                                   <h2 style={{
                                       margin: 0,
                                       fontSize: '18px',
                                       fontWeight: '700',
                                       lineHeight: '1.4',
                                       color: '#1f2937',
                                       minHeight: '50px',
                                       display: '-webkit-box',
                                       WebkitLineClamp: 2,
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden'
                                   }}>
                                       <Link 
                                           onClick={() => { savePageNumber(); ClickHandler(); }}
                                           to={props.component === "course" ? `/course-single/${course.courseId}` : `/Instructor/CourseDetail/${course.courseId}`}
                                           style={{
                                               color: '#1f2937',
                                               textDecoration: 'none',
                                               transition: 'color 0.3s ease'
                                           }}
                                           onMouseEnter={(e) => e.currentTarget.style.color = '#667eea'}
                                           onMouseLeave={(e) => e.currentTarget.style.color = '#1f2937'}
                                       >
                                           {course.courseName}
                                       </Link>
                                   </h2>
                                   
                                   {/* Stats */}
                                   <div style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '20px',
                                       paddingTop: '12px',
                                       borderTop: '1px solid #e5e7eb',
                                       marginTop: 'auto'
                                   }}>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '6px',
                                           color: '#6b7280',
                                           fontSize: '14px'
                                       }}>
                                           <span style={{ fontSize: '16px' }}>👥</span>
                                           <span style={{ fontWeight: '500' }}>{course.student || 0}</span>
                                       </div>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '6px',
                                           color: '#6b7280',
                                           fontSize: '14px'
                                       }}>
                                           <span style={{ fontSize: '16px' }}>📖</span>
                                           <span style={{ fontWeight: '500' }}>{course.lesson || 0} Ders</span>
                                       </div>
                                   </div>
                                   
                                   {/* Edit Button for Instructor */}
                                   {props.component === "instructor" && (
                                       <button 
                                           onClick={() => handleClickedChildToParent(course.courseId)}
                                           style={{
                                               marginTop: '12px',
                                               width: '100%',
                                               padding: '12px',
                                               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                               color: '#fff',
                                               border: 'none',
                                               borderRadius: '10px',
                                               fontSize: '14px',
                                               fontWeight: '600',
                                               cursor: 'pointer',
                                               transition: 'all 0.3s ease',
                                               boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                                           }}
                                           onMouseEnter={(e) => {
                                               e.currentTarget.style.transform = 'translateY(-2px)';
                                               e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                                           }}
                                           onMouseLeave={(e) => {
                                               e.currentTarget.style.transform = 'translateY(0)';
                                               e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                           }}
                                       >
                                           ✏️ Düzenle
                                       </button>
                                   )}
                               </div>
                           </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseSectionS3;